module.exports = __webpack_public_path__ + "static/media/HomeStoryLogo1.8b60a648.png";